/**
 * Parses a template string and replaces placeholders with the corresponding values or components.
 *
 * Usage:
 * const template = "<icon> Hello, <name>!";
 * const placeholderMap = { icon: <Icon name="Profile" />, name: "John" };
 * const parsedTemplate = parseTemplate(template, placeholderMap);
 * console.log(parsedTemplate); // "<Icon name="Profile" /> Hello, John!"
 *
 * @param template - The template string to parse.
 * @param placeholderMap - A map of placeholders to their corresponding values.
 * @returns The parsed string with placeholders replaced by their values.
 */
export const parseTemplate = (
  template: string,
  placeholderMap: Record<string, React.ReactNode>,
) => {
  return template
    .split(/(<[^>]+>)/)
    .map((part) => placeholderMap[part as keyof typeof placeholderMap] || part);
};
